<template>
     <div class="PasswordChangeRequestView">
          <PasswordChangeRequestCmp />
     </div>
</template>
<script>
     import PasswordChangeRequestCmp from "@/components/PasswordChangeRequestCmp.vue";

     export default {
          name      : "PasswordChangeRequestView",
          components: {
               PasswordChangeRequestCmp
          }
     };
</script>